// uuid v7+ removed deep import paths; use named export instead.
import { v4 as uuid } from 'uuid'
import localforage from 'localforage'
import * as types from '../mutation-types'
import { storeClient } from '@/service/apiClients'

function newAgentId () {
  const newAgentId = uuid()
  localforage.setItem('agentId', newAgentId)
  return newAgentId
}

const uuidV4Regex = '^[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[4][a-fA-F0-9]{3}-[89abAB][a-fA-F0-9]{3}-[a-fA-F0-9]{12}$'

export default async store => {
  const currentAgentId = await localforage.getItem('agentId')
  const agentId = new RegExp(uuidV4Regex).test(currentAgentId) ? currentAgentId : newAgentId()

  store.commit(types.SET_AGENT_ID, agentId)
  storeClient.defaults.headers.common['agent-id'] = agentId

  // store.dispatch('orderModule/getHistoryOrders')
}
